import { Button } from "@libs/zapi-ui/ds/components/button";

type TProps = {
  isPending: boolean;
  onClear: () => void;
};

export function PortfolioInvalidUrlState({ isPending, onClear }: TProps) {
  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-2">
      <p className="text-[14px] text-zinc-500 font-normal text-center">
        Template is configured to an inaccessible server. <br /> Please clear the URL and try again.
      </p>
      <Button
        type="button"
        size="sm"
        variant="outline"
        onClick={onClear}
        disabled={isPending}
        data-testid="portfolio-invalid-url-clear-button"
        className="flex items-center gap-2"
      >
        Clear
      </Button>
    </div>
  );
}
